import { Reducer, Action } from "redux";
import { CurrencySettingsState, KnownOrderPadAction, unloadedAppCurrencySettingsState } from ".";

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

export const reducer: Reducer<CurrencySettingsState> = (state: CurrencySettingsState | undefined, incomingAction: Action): CurrencySettingsState => {
  if (state === undefined) {
    return unloadedAppCurrencySettingsState;
  }

  const action = incomingAction as KnownOrderPadAction;
  switch (action.type) {
    case "SET_APP_CURRENCY":
      return {
        app: action.appStatePassedIn
      }
  }

  return state;
};
